module.exports = __webpack_public_path__ + "img/double-image-hero-kia.cf66c751.png";